class ScopeSubscription {
	id = '';
	name = '';
	type = '';
	plan = null;
	createdAt = null;
	updatedAt = null;
	isPrepaid = false;
	isTrial = false;
	isPromo = false;
	isBasic = false;
	prepaidCouponId = null;
	cancelAtPeriodEnd = false;
	transitionAtEnd = false;
	expiry = null;
	renews = false;
	trialExpiry = null;
	isLegacy = false;
	isPerpetual = false;
	maintenanceEnds = null;
	maintenancePeriod = null;
}

export default ScopeSubscription;



// WEBPACK FOOTER //
// ./src/store/models/scope-subscription.js